import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Effect } from "../types/effects";
import { RootState } from "./store";

interface EffectsState {
  videoEffects: Effect[];
  photoEffects: Effect[];
  videoEffectsLastVisible: any;
  photoEffectsLastVisible: any;
  hasMoreVideoEffects: boolean;
  hasMorePhotoEffects: boolean;
  showVideoEffectsModal: boolean;
  showPhotoEffectsModal: boolean;
}

const initialState: EffectsState = {
  videoEffects: [],
  photoEffects: [],
  videoEffectsLastVisible: null,
  photoEffectsLastVisible: null,
  hasMoreVideoEffects: true,
  hasMorePhotoEffects: true,
  showVideoEffectsModal: false,
  showPhotoEffectsModal: false,
};

const effectsSlice = createSlice({
  name: "effects",
  initialState,
  reducers: {
    setVideoEffects: (state, action: PayloadAction<Effect[]>) => {
      state.videoEffects = action.payload;
    },
    setPhotoEffects: (state, action: PayloadAction<Effect[]>) => {
      state.photoEffects = action.payload;
    },
    addVideoEffects: (state, action: PayloadAction<Effect[]>) => {
      state.videoEffects = [...state.videoEffects, ...action.payload];
    },
    addPhotoEffects: (state, action: PayloadAction<Effect[]>) => {
      state.photoEffects = [...state.photoEffects, ...action.payload];
    },
    setVideoEffectsLastVisible: (state, action: PayloadAction<any>) => {
      state.videoEffectsLastVisible = action.payload;
    },
    setPhotoEffectsLastVisible: (state, action: PayloadAction<any>) => {
      state.photoEffectsLastVisible = action.payload;
    },
    setHasMoreVideoEffects: (state, action: PayloadAction<boolean>) => {
      state.hasMoreVideoEffects = action.payload;
    },
    setHasMorePhotoEffects: (state, action: PayloadAction<boolean>) => {
      state.hasMorePhotoEffects = action.payload;
    },
    setShowVideoEffectsModal: (state, action: PayloadAction<boolean>) => {
      state.showVideoEffectsModal = action.payload;
    },
    setShowPhotoEffectsModal: (state, action: PayloadAction<boolean>) => {
      state.showPhotoEffectsModal = action.payload;
    },
  },
});

export const {
  setVideoEffects,
  setPhotoEffects,
  addVideoEffects,
  addPhotoEffects,
  setVideoEffectsLastVisible,
  setPhotoEffectsLastVisible,
  setHasMoreVideoEffects,
  setHasMorePhotoEffects,
  setShowVideoEffectsModal,
  setShowPhotoEffectsModal,
} = effectsSlice.actions;

export const selectVideoEffects = (state: RootState) =>
  state.effects.videoEffects;
export const selectPhotoEffects = (state: RootState) =>
  state.effects.photoEffects;
export const selectVideoEffectsLastVisible = (state: RootState) =>
  state.effects.videoEffectsLastVisible;
export const selectPhotoEffectsLastVisible = (state: RootState) =>
  state.effects.photoEffectsLastVisible;
export const selectHasMoreVideoEffects = (state: RootState) =>
  state.effects.hasMoreVideoEffects;
export const selectHasMorePhotoEffects = (state: RootState) =>
  state.effects.hasMorePhotoEffects;
export const selectShowVideoEffectsModal = (state: RootState) =>
  state.effects.showVideoEffectsModal;
export const selectShowPhotoEffectsModal = (state: RootState) =>
  state.effects.showPhotoEffectsModal;

export default effectsSlice.reducer;
